import { Typography, Link } from '@mui/material';

const address = "1003 E 106th St, Carmel, IN 46280";
const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

export default function AddressLink() {
  return (
    <Typography variant="body2">
      <Link
        href={mapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        color="#d89936"
        fontFamily={'lulo-one'}
      >
        {address}
      </Link>
    </Typography>
  );
}